import Modal from "./_bootstrapModalExtensions";

export function ShowHelper(useThisKey: string, force: boolean) {
    let helperKey: string = useThisKey || window.ETDR_RD.appConfig["ViewData.HelperKey"];

    // No key provided (either parameter or "passively" from appConfig)
    if (!helperKey) {
        return;
    }

    // Determine whether to use the DB (ajax query) or the localStorage for the "do not show again" information
    let useDb: boolean = window.ETDR_RD.appConfig["Config.SaveHelperStateToDatabase"];
    let url: string = force ? window.ETDR_RD.appConfig["UrlAction.GetHelperSystemParameter"] : window.ETDR_RD.appConfig["UrlAction.GetHelperByUserSystemParameter"];

    if (useDb || !window.localStorage['skip-' + helperKey]) {

        $.ajax({
            url: url,
            method: 'POST',
            data: { "HelperKey": helperKey },
            success: (data: string, textStatus: string, jqXHR: JQuery.jqXHR<any>) => {

                // The response was invalid (or the user desires no helpers, probably disabled it or all of it)
                if (!data || data.length === 0) {
                    return;
                }

                Modal.showConfirmationWindowAsync(
                    data,
                    'Segítség az oldal használatához',
                    () => {
                        HideHelper(helperKey);
                    },
                    () => {

                    },
                    "Ne jelenjen meg többé ez az üzenet",
                    "Bezárás");
            },
            error: (jqXHR: JQuery.jqXHR<any>, textStatus: String, errorThrown: String) => {
                var responseData = JSON.parse(jqXHR.responseText);

                Modal.showAlertWindow(
                    responseData.message,
                    'Hiba!');
            }
        });
    }
};

export function HideHelper(helperKey: string) {
    // Save to DB or localStorage
    let useDb: boolean = window.ETDR_RD.appConfig["Config.SaveHelperStateToDatabase"];

    if (useDb) {
        $.ajax({
            method: "POST",
            url: window.ETDR_RD.appConfig["UrlAction.UserHelperSkipActionUserHelperSkip"],
            data: { "HelperKey": helperKey }
        });
    }
    else {
        window.localStorage['skip-' + helperKey] = true;
    }
};

export function IsNullOrWhitespace(input: string) {
    return input.trim() === '';
}
